module.exports = __webpack_public_path__ + "static/media/dengchao.41175cc7.jpg";